export const backendUrl = "127.0.0.1:5000"; // not used yet

export const buyInConfig = {
  UPPER_BB: 300,
  DEFAULT_BB: 100,
  LOWER_BB: 50,
};
